import { useQuery } from '@tanstack/react-query';
import api from 'services/api/api';

export const getUsersList = async () => {
	const response = await api.get('/auth/listUsuarios');
	return response.data;
};
export const useGetUsersList = () => {
	return useQuery(['users-list'], getUsersList, {
		refetchOnWindowFocus: false,
	});
};
